import { Container, Skeleton, Typography } from "@mui/material";
import ReactJson from '@microlink/react-json-view'

type JsonViewScreenProps = {
    title: string;
    subtitle: string;
    data: string;
    loading: boolean;
  }

export default function JsonViewScreen({ title, subtitle, data, loading }: JsonViewScreenProps) {
  const jsonData = JSON.parse(data);
  return (
    <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h3">
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="h4">
          {subtitle}
        </Typography>
      )}
      {loading ? (
                <>
                  <Skeleton variant="text" sx={{ m: 2, width: "80%" }} />
                  <Skeleton variant="text" sx={{ m: 2, width: "80%" }} />
                  <Skeleton variant="text" sx={{ m: 2, width: "80%" }} />
                </>
              ) : (
                <ReactJson src={jsonData} collapsed={1} />
              )
        }
    </Container>
  )
}
